import { Button, Modal } from 'rsuite';
import styles from './ModalUnderstandBetter.module.scss';

interface ModalUnderstandBetterProps {
  show?: boolean;
  onCancel?: () => void;
}

export const ModalUnderstandBetter = ({ show, onCancel }: ModalUnderstandBetterProps) => (
  <Modal overflow={false} backdrop="static" show={show} className={styles['modulo-relatorio-modal-understand-better']} onHide={onCancel} size="md">
    <Modal.Body>
      <h5 className={styles.title}>Entenda como calculamos a competitividade</h5>
      <div className="content">
        <p className={styles['bold-text']}>Correspondência de preços</p>
        <p>Para calcular a competitividade, consideramos apenas os preços de produtos e redes que estão presentes em todos os canais analisados. </p>
        <p className={styles['bold-text']}>Período selecionado</p>
        <p>
          O cálculo de competitividade leva em consideração a média dos preços no período selecionado, consolidados semanalmente com os preços coletados entre
          domingo e sábado de cada semana. O período leva em consideração as semanas fechadas somadas até a última atualização.
        </p>
        <p className={styles['bold-text']}>Cálculo de competitividade</p>
        <p>
          Para cada produto, dividimos o preço praticado no canal físico pelo preço correspondente nos canais digitais em cada uma das redes. O resultado é um
          índice com base 100:
        </p>
        <ul className={styles.list}>
          <li>Valores acima de 100 indicam que o canal físico está mais caro.</li>
          <li>Valores abaixo de 100 indicam que o canal físico está mais barato.</li>
        </ul>
        <p>
          Calculamos a média desses índices por produto para obter o índice de competitividade da rede em cada canal. Por fim, a competitividade geral da rede é
          a média dos índices de todos os canais analisados.
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onCancel} appearance="primary">
        Fechar
      </Button>
    </Modal.Footer>
  </Modal>
);
